<h1 mat-dialog-title>Collega PEC</h1>
<div mat-dialog-content>
  <app-pec-lists [withFilter]="withFilter" [withSearchBar]="withSearchBar" [viewMode]="viewMode" [addButton]="addButton" (selectedPec)="selectedPec($event)"></app-pec-lists>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="currentPec" [disabled]="!currentPec">{{ confirmButtonLabel |
    translate }}</button>
  <button mat-button [mat-dialog-close]="">{{ cancelButtonLabel | translate }}</button>
</div>